import { React, useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form, Field } from "formik";
import {
  Col,
  Container,
  Row,
  Button,
} from "reactstrap";
import { ReactstrapInput } from "reactstrap-formik";
import config from "../../store/config";
import { sendAddressBookLogin } from "../../store/address-book-actions";

import * as Yup from "yup";

function AddressBookLoginForm() {
  const dispatch = useDispatch();

  const formRef = useRef();
  const addressBookState = useSelector((state) => state.addressBook);
  const [passwordLabel, setPasswordLabel] = useState("Send Password Reset Email");
  const [resetPasswordVisible, setResetPasswordVisible] = useState(false);
  const [forgotPasswordErrorMsg, setForgotPasswordErrorMsg] = useState("");
  const [forgotPasswordConfirmMsg, setForgotPasswordConfirmMsg] = useState("");

  // init form validation schema
  const formSchema = Yup.object().shape({
    emailAddress: Yup.string().required("Required"),
    password: Yup.string().required("Required"),
  });

  const showResetPassword = async (e) => {
    setResetPasswordVisible(true);
  };

  const submitForgotPassword = async (e) => {
    setForgotPasswordErrorMsg("");

    if(formRef.current.values.emailAddress == "") {
      setForgotPasswordErrorMsg("Please enter a valid email address.");
      return;
    }

    setPasswordLabel("Please wait...");

    await sendForgotPassword(formRef.current.values.emailAddress);
    setForgotPasswordConfirmMsg("Please check your email for a link to reset your password. Do not close this window. After you reset your password, you will be able to sign in here.");
  
    setPasswordLabel("Send Password Reset Email");
  };

  async function sendForgotPassword(emailAddress) {
    const body = {
      Email: emailAddress,
      __RequestVerificationToken: window.AntiForgeryToken
    };

    try {
      const response = await fetch(config.settings.apiEndpoint + "api/requests/SendPasswordReset", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'X-CSRF-TOKEN': window.AntiForgeryToken
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        return { success: false, error: "" };
      }

      return { success: true };

    } catch (err) {
      setForgotPasswordErrorMsg("Password reset request error: " + err.message);
      console.error("Password reset request error:", err);
      return { success: false, error: err.message };
    }
  }

  function formSubmitHandler(values) {
    dispatch(
      sendAddressBookLogin({
        EmailAddress: values.emailAddress,
        Password: values.password,
      })
    );
  }

  return (
    <div>
      <p><strong>Please Sign In</strong></p>
      {(addressBookState.LoginAttemptResponse) && (
        <p style={{ color: '#ff0000' }}>
          {addressBookState.LoginAttemptResponse}
        </p>
      )}
      <Formik
        initialValues={{
          emailAddress: "",
          password: "",
        }}
        validationSchema={formSchema}
        onSubmit={formSubmitHandler}
        innerRef={formRef}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          setFieldTouched,
        }) => (
          <Form className="text-start address-book-login-form">
            <Container className="cfg-form-section">
              <Row className="mb-4">
                <Col xs="12">
                  <label className="required" htmlFor="emailAddress">
                    Email Address:
                  </label>
                  <Field
                    name="emailAddress"
                    id="emailAddress"
                    component={ReactstrapInput}
                    onBlur={(e) => {
                      handleBlur(e);
                    }}
                  />
                </Col>
              </Row>
              <Row className="mb-4">
                <Col xs="12">
                  <label className="required" htmlFor="password">
                    Password:
                  </label>
                  <Field
                    name="password"
                    id="password"
                    type="password"
                    component={ReactstrapInput}
                    onBlur={(e) => {
                      handleBlur(e);
                    }}
                  />
                </Col>
              </Row>
              <Row className="mb-4">
                <Col xs="12">
                  <Button type="submit" size="sm" color="primary">
                    Log In
                  </Button>

                  {!resetPasswordVisible && <a href="#" onClick={showResetPassword} style={{ marginLeft: '20px' }}>Forgot your password?</a>}
                  {resetPasswordVisible && <Button onClick={submitForgotPassword} style={{ marginLeft: '20px' }} type="button" size="sm" color="secondary">
                  {passwordLabel}
                  </Button>}


                  {forgotPasswordErrorMsg != "" && <div className="alert alert-danger" style={{ margin: "20px 0" }} role="alert">{forgotPasswordErrorMsg}</div>}
                  {forgotPasswordConfirmMsg != "" && <div className="alert alert-success" style={{ margin: "20px 0" }} role="alert">{forgotPasswordConfirmMsg}</div>}
                </Col>
              </Row>
            </Container>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AddressBookLoginForm;
